import { useDispatch, useSelector } from 'react-redux';
import { getCurrentUser } from 'src/selectors/currentUser';
import UserPreferencesSystem from 'src/systems/UserPreferencesSystem';
import GuestUserPreferencesSystem from 'src/systems/GuestUserPreferencesSystem';
import { useCallback } from 'react';
import UserPreferences from 'src/entities/userPreferences';

export type UseReduxUserPreferencesParams = {
	shareRef?: string;
}

const useReduxUserPreferences = ( { shareRef }: UseReduxUserPreferencesParams ) => {
	const dispatch = useDispatch();
	const currentUser = useSelector( state => getCurrentUser( state ) );
	const currentUserPrefferedImageResolution = (
		currentUser?.preferences?.assetDownloadsResolution || UserPreferences.assetDownloadsResolutions.original
	);

	const updateImageResolutionPreference = useCallback( ( resolution: string ) => {
		const userPreferencesSystem = shareRef
			? new GuestUserPreferencesSystem( dispatch )
			: new UserPreferencesSystem( dispatch );

		userPreferencesSystem.setAssetDownloadResolution( resolution );
	}, [ dispatch, shareRef ] );

	return {
		currentUserPrefferedImageResolution,
		updateImageResolutionPreference
	}
}

export default useReduxUserPreferences;
